export enum Gender {
  MALE = '先生',
  FEMALE = '女士'
}

export interface GuessEntry {
  id: string;
  name: string;
  gender: Gender;
  phone: string;
  chinaGolds: number;
  germanyGolds: number;
  timestamp: number;
  aiCommentary?: string;
}

export interface HistoricalData {
  year: number;
  city: string;
  china: number;
  germany: number;
}

